/* src/app/components/proposal/proposal.component.css */
/*# sourceMappingURL=proposal.component.css.map */
